import { render, staticRenderFns } from "./BaseMaterialDesignIcon.vue?vue&type=template&id=4f52aa30"
import script from "./BaseMaterialDesignIcon.vue?vue&type=script&lang=js"
export * from "./BaseMaterialDesignIcon.vue?vue&type=script&lang=js"
import style0 from "./BaseMaterialDesignIcon.vue?vue&type=style&index=0&id=4f52aa30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports